/* eslint-disable @typescript-eslint/prefer-namespace-keyword */
/* eslint-disable @typescript-eslint/no-namespace */

import { neverHere } from "./tsHelpers";

// PLEASE DO NOT ADD NEW HELPERS HERE!
//
// See instead, for example, ./enum/pdfJobTypeEnumHelper.ts
// and its re-export at the bottom of this file.

export class EnumHelper {
  public static getMessageTypeDescription(type: MessageType) {
    switch (type) {
      case MessageType.InitialEnquiry:
        return "Initial enquiry";
      case MessageType.Itinerary:
        return "Itinerary";
      case MessageType.Text:
        return "Text";
      default:
        neverHere(type);
    }
  }

  public static getComponentTypeDescription(type: ComponentType) {
    switch (type) {
      case ComponentType.Excursion:
        return "Excursion";
      case ComponentType.Transfer:
        return "Transfer";
      case ComponentType.Accommodation:
        return "Accommodation";
      default:
        neverHere(type);
    }
  }

  public static getSampleItineraryStatusDescription(type: SampleItineraryStatus) {
    switch (type) {
      case SampleItineraryStatus.Draft:
        return "Draft";
      case SampleItineraryStatus.Live:
        return "Live";
      default:
        neverHere(type);
    }
  }

  public static getTripType(type: TripType) {
    switch (type) {
      case TripType.Comfortable:
        return "Comfortable";
      case TripType.Luxury:
        return "Luxury";
      case TripType.Simple:
        return "Simple";
      case TripType.Unknown:
        return "A mixture";
      case TripType.Boutique:
        return "Boutique/ character";
      default:
        neverHere(type);
    }
  }

  public static getIndependenceLevel(type: IndependenceLevel) {
    switch (type) {
      case IndependenceLevel.FullyGuided:
        return "Fully guided";
      case IndependenceLevel.FullyIndependent:
        return "Fully independent";
      case IndependenceLevel.PartiallyGuided:
        return "Partially guided";
      case IndependenceLevel.Unknown:
        return "I don't know";
      default:
        neverHere(type);
    }
  }

  public static getTravelDateFlexibility(type: TravelDateFlexibility) {
    switch (type) {
      case TravelDateFlexibility.ExactDates:
        return "Exact dates";
      case TravelDateFlexibility.RoughDates:
        return "Rough dates";
      case TravelDateFlexibility.Unknown:
        return "No dates";
      default:
        neverHere(type);
    }
  }

  public static getLocationType(type: LocationType) {
    switch (type) {
      case LocationType.Country:
        return "Country";
      case LocationType.Destination:
        return "Destination";
      case LocationType.Region:
        return "Region";
      case LocationType.Airport:
        return "Airport";
      default:
        neverHere(type);
    }
  }

  public static getPaymentType(type: PaymentType) {
    switch (type) {
      case PaymentType.Booking:
        return "Booking";
      case PaymentType.Installment:
        return "Installment";
      default:
        neverHere(type);
    }
  }

  public static getLocationStatus(type: LocationStatus) {
    switch (type) {
      case LocationStatus.Available:
        return "Available";
      case LocationStatus.Draft:
        return "Draft";
      case LocationStatus.Live:
        return "Live";
      default:
        neverHere(type);
    }
  }

  public static getItineraryType(type: ItineraryType) {
    switch (type) {
      case ItineraryType.Sample:
        return "Sample";
      case ItineraryType.Enquiry:
        return "Enquiry";
      default:
        neverHere(type);
    }
  }

  public static getWeatherQuality(type: WeatherQuality) {
    switch (type) {
      case WeatherQuality.Bad:
        return "Bad";
      case WeatherQuality.Neutral:
        return "Neutral";
      case WeatherQuality.Good:
        return "Good";
      default:
        neverHere(type);
    }
  }

  public static getComponentStatus(type: ComponentStatus) {
    switch (type) {
      case ComponentStatus.Locked:
        return "Locked";
      case ComponentStatus.Editable:
        return "Editable";
      case ComponentStatus.Archived:
        return "Archived";
      default:
        neverHere(type);
    }
  }

  public static getReviewStatus(type: ReviewStatus) {
    switch (type) {
      case "draft":
        return "Draft";
      case "live":
        return "Live";
      default:
        neverHere(type);
    }
  }

  public static getPublishStatus(type: PublishStatus) {
    switch (type) {
      case PublishStatus.Draft:
        return "Draft";
      case PublishStatus.Live:
        return "Live";
      default:
        neverHere(type);
    }
  }
}

// this is not legal TypeScript syntax:
//   export * as PdfJobTypeEnumHelper from "./enum/pdfJobTypeEnumHelper";
// so:

import * as PdfJobTypeEnumHelper from "./enum/pdfJobTypeEnumHelper";
export { PdfJobTypeEnumHelper };
import * as LocationImageTypeEnumHelper from "./enum/locationImageTypeEnumHelper";
export { LocationImageTypeEnumHelper };
import * as EnquiryStatusEnumHelper from "./enum/enquiryStatusEnumHelper";
export { EnquiryStatusEnumHelper };
import * as LocationTypeEnumHelper from "./enum/locationTypeEnumHelper";
export { LocationTypeEnumHelper };
import * as LtoStatusEnumHelper from "./enum/ltoStatusEnumHelper";
export { LtoStatusEnumHelper };
import * as ItineraryStatusEnumHelper from "./enum/itineraryStatusEnumHelper";
export { ItineraryStatusEnumHelper };
import * as PaymentStatusEnumHelper from "./enum/paymentStatusEnumHelper";
export { PaymentStatusEnumHelper };
import * as ContentTypeEnumHelper from "./enum/contentTypeEnumHelper";
export { ContentTypeEnumHelper };
import * as MonthEnumHelper from "./enum/monthEnumHelper";
export { MonthEnumHelper };
import * as TransferTypeEnumHelper from "./enum/transferTypeEnumHelper";
export { TransferTypeEnumHelper };
import * as UserTypeEnumHelper from "./enum/userTypeEnumHelper";
export { UserTypeEnumHelper };
import * as PlanningStageEnumHelper from "./enum/planningStageEnumHelper";
export { PlanningStageEnumHelper };
